import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import saveQuestionFile from "./saveQuestionFile";
import createAnswer from "./createAnswer";
import uri from "../../../constants/uri";
import { questionTypeToBackendType } from "../../../constants/answerType";

const createQuestion = async (question, votingId, order) => {
	const { obligatory: Obligatory, answerType, title: Text } = question;
	const {
		data: { id: questionId },
	} = await client.post(
		`${uri}/question`,
		{
			VotingId: votingId,
			TypeId: questionTypeToBackendType[answerType],
			OrderNum: order,
			Text,
			Obligatory,
		},
		{
			headers: authHeader(),
		}
	);

	if (question.files) {
		await Promise.all(
			question.files.map((file) => saveQuestionFile(file, questionId))
		);
	}

	if (answerType === "text") {
		await createAnswer(
			{
				text: "Ваш ответ",
			},
			questionId,
			1,
			"writing"
		);
		return;
	}

	if (question.answers) {
		for (const answerOrder in question.answers) {
			await createAnswer(
				question.answers[answerOrder],
				questionId,
				Number(answerOrder),
				"choosing"
			);
		}
	}
	if (question.haveOtherOption) {
		await createAnswer(
			{
				text: "Другое",
			},
			questionId,
			question.answers.length,
			"writing"
		);
	}
};

export default createQuestion;
